// TODO traducir exito erro a español y nombre interface
export enum TipoDatePickerEnum {
  Fecha = 'fecha',
  Hora = 'hora',
  FechaHora = 'fechaHora',
  FechaRango = 'fechaRango',
}
